
import axios from 'axios';

const PROD_HOST = 'tweebaa.com';

const TEST_CN_OLD_HOST = 'http://47.101.219.248';

var navLanguage = navigator.language.toLowerCase();
var language;

// var languages = ['zh','zh-cn','cn'];
// language = languages.includes(navLanguage) ? 'zh' : 'en';

if (navLanguage.indexOf('zh') > -1 || navLanguage.indexOf('cn') > -1) {
    language = 'zh';
} else {
    language = 'en';
}

var host = window.location.host;

function getAxois(url,method,perms) {
    return axios({
        method:method,
        url:url,
        data:perms,

    })
}

function getNodeAxois(url,method,perms) {
    return axios({
        method:method,
        url:url,
        data:perms,
    })
}

//获取当前用户使用API
function getBaseUrl() {
    // return "https://api2.tweebaa.cn/";
    // return "http://api.tweebaa.cn/";
    return 'https://manage.tweebaa.cn/tweebaa-api/';
}

//获取当前用户使用API
function getBaseUrl2() {
    // return "http://njuser2.tweebaa.cn/";
    // return 'https://api.tycoonplace.com/';
    return "https://api.tweebaa.cn/";
}

function getSuggestUrl() {
    // return "https://product.tweebaa.cn";
    return 'https://manage.tweebaa.cn/suggest-api';
}

function getTweeLogUrl() {
    // if (host === PROD_HOST) {
        return 'https://manage.tweebaa.cn/tweelog-api';
    // } else {
    //     return TEST_CN_OLD_HOST + ':10012';
    // }
}

function getMomentUrl() {
    if (host === PROD_HOST) {
        return "https://manage.tweebaa.cn/moment-api";
    } else {
        return TEST_CN_OLD_HOST + ':8131';
    }
}

function getActivityUrl() {
    if (host === PROD_HOST) {
        return "https://manage.tweebaa.cn/activity-api";
    } else {
        return TEST_CN_OLD_HOST + ':10012';
    }
}

function getUserCenterUrl() {
    // return 'http://47.101.219.248:8124';
    return 'https://user.tweebaa.cn';
}

// //获取nodeJs API
function getNodeApiUrl() {
    return "https://tweebaa.cn/api/v1/";
}
//获取NodeJs uas Api
function getUASApi() {
    return 'https://tweebaa.cn/api/v1/uas/';
}

function getFreeApi() {
    return 'https://manage.tweebaa.cn'
}

//获取系统类型
function getPhoneSystem() {
    var client;
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        client = 'ios';
    } else if (/(Android)/i.test(navigator.userAgent)) {
        client = 'Android';
    } else {
        client = 'PC';
    }
    return client;
}

//获取url 对象及参数
function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}
function getUrlParam(parameter){
    var urlparameter = '';
    if(window.location.href.indexOf(parameter) > -1){
        urlparameter = getUrlVars()[parameter];
    }
    return urlparameter;
}

function getL() {
    return "PLAY2-3PBvt-QeA3p-Bx4Tu-6kheX-akyZ7"
}

function initRate() {
    //获取汇率信息
    getAxois(getBaseUrl() + "api/tweebucks/v1/rates", "GET", {}).then(function (response) {
        var exChangeCNY = response.data.CNY / 10;
        var exchangeValue;
        if (language === 'zh') {
            exchangeValue = exChangeCNY;
        } else {
            exchangeValue = 0.1;
        }
        localStorage.setItem('exChangeCNY', exChangeCNY);
    });
}

function getExchangeText(price) {
    if (!price) {
        return price;
    }
    price = +price;
    var exchange = 0.1;
    var currency = '$';
    if (language === 'zh') {
        exchange = localStorage.getItem('exChangeCNY') || 0.67;
        currency = '￥';
    } else {
        exchange = 0.1;
        currency = '$';
    }
    return '≈' + currency + (price * exchange).toFixed(2);
}

function jmz(str) {
    var realLength = 0, len = str.length, charCode = -1;
    for (var i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);
        if (charCode >= 0 && charCode <= 128) realLength += 1;
        else realLength += 2;
    }
    return realLength;
}

function isMobile() {
    const userAgentInfo = navigator.userAgent;
    const Agents = [
        'Android',
        'iPhone',
        'iPad',
        'iPod'
    ];
    let flag = false;
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = true;
            break
        }
    }
    return flag;
}

export default {
    getFreeApi,
    language,
    getAxois,
    getNodeAxois,
    getBaseUrl,
    getBaseUrl2,
    getSuggestUrl,
    getNodeApiUrl,
    getUASApi,
    getPhoneSystem,
    getUrlVars,
    getUrlParam,
    getL,
    initRate,
    getExchangeText,
    jmz,
    isMobile,
    getUserCenterUrl,
    getMomentUrl,
    getTweeLogUrl,
    getActivityUrl
}


